import { render, staticRenderFns } from "./ThreadMessages.vue?vue&type=template&id=5a59f294&"
import script from "./ThreadMessages.vue?vue&type=script&lang=js&"
export * from "./ThreadMessages.vue?vue&type=script&lang=js&"
import style0 from "./ThreadMessages.vue?vue&type=style&index=0&id=5a59f294&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports